import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { C } from "@/theme";
import { fmtDate } from "@/format";
import { Card, Field, Picker, StarRating, FormScreen } from "@/ui";
import { useAuth } from "@/auth";

export default function FeedbackForm() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { user } = useAuth();
  const isRider = user?.role === "Rider" && !!user.rider_id;
  const [runId, setRunId] = useState("");
  const [session, setSession] = useState(5);
  const [trainer, setTrainer] = useState(5);
  const [comments, setComments] = useState("");
  const runsQ = useQuery({ queryKey: ["runs"], queryFn: () => api.get("/runs") });
  const availableRuns = (runsQ.data ?? []).filter((r) => !isRider || r.rider_id === user.rider_id);
  const selectedRun = (runsQ.data ?? []).find((r) => r.id === runId);
  const save = useMutation({
    mutationFn: () => api.post("/feedback", { run_id: runId, rider_id: selectedRun?.rider_id ?? "", session_rating: session, trainer_rating: trainer, comments }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["feedback"] }); qc.invalidateQueries({ queryKey: ["runs"] }); navigate(-1); },
  });
  return (
    <FormScreen title="Add Feedback" onClose={() => navigate(-1)} onSave={() => save.mutate()} saving={save.isPending} saveDisabled={!runId}>
      <Picker label="Training Run" testID="feedback-run-picker" placeholder="Select a session" searchable value={runId} onSelect={setRunId} options={availableRuns.map((r) => ({ key: r.id, label: `${r.rider_name} · ${r.location}`, sub: `${fmtDate(r.date)} · ${r.run_type}` }))} />
      <Card>
        <div className="flex items-center justify-between"><span style={{ color: C.onSurface }} className="text-[15px] font-bold">Session Rating</span><StarRating value={session} onChange={setSession} size={26} testID="feedback-session-rating" /></div>
        <div className="flex items-center justify-between mt-4"><span style={{ color: C.onSurface }} className="text-[15px] font-bold">Tutor Rating</span><StarRating value={trainer} onChange={setTrainer} size={26} testID="feedback-trainer-rating" /></div>
      </Card>
      <Field label="Comments" value={comments} onChange={setComments} multiline placeholder="Share your thoughts on the session" testID="feedback-comments" />
    </FormScreen>
  );
}
